import MyBackButton from "../components/MyBackButton";


interface MyMainLayoutProps {
  label?: any;
  top?: React.ReactNode;
  topCaroasal?: React.ReactNode;
  mainTopScroller?: React.ReactNode;
  main?: React.ReactNode;
  bottom?: React.ReactNode;
  bottom2?: React.ReactNode;
  leftSideItems?: React.ReactNode;
  onBack?: ()=>void;
}


export default function MyMainLayout({
  top,
  topCaroasal,
  mainTopScroller,
  main,
  leftSideItems,
  label,
  bottom,
  bottom2,
  onBack
}: MyMainLayoutProps) {
  return (
    <section className="flex flex-col w-full min-h-screen  p-4 md:p-6 lg:p-6 mt-[50px] overflow-x-hidden">

      {/* TOP AREA */}
      <div>{top}</div>

      {/* HEADER LABEL */}
      {/* {label && <MyHeaderLabel label={label} />} */}

      {topCaroasal &&<div className="py-3 px-2">{topCaroasal}</div>}

      {mainTopScroller &&<div className="py-6 h-[350px]">{mainTopScroller}</div>}

      {/* MAIN + SIDEBAR ROW */}
      <div className="w-full flex gap-4 justify-between pt-9">
        <div className="w-full h-full min-w-0 flex flex-col gap-2">
          
          <div className="h-full"> {main}</div>
         
        </div>

        {/* SIDEBAR */}
        {leftSideItems && (
          <aside className="hidden lg:block w-[300px]  flex-shrink-0">
            <div className="sticky top-13 ">
              {leftSideItems}
            </div>
          </aside>
        )}

      </div>

      {/* BOTTOM CONTENT */}
      {bottom &&<div className="py-5">{bottom}</div>}
      {bottom2 &&<div className="py-5">{bottom2}</div>}
    </section>
  );
}